module.exports = __webpack_public_path__ + "img/sv10.d8f51fdb.svg";